import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {

    create: async ({ mission_id, action, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "notes/";

        const body = JSON.stringify({
            notes: {
                mission_id: mission_id,
                action: action,
            }
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                credentials: 'include',
                body: body
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

}